import { laboratoryClient } from '../utils/laboratoryClient';
import { useEffect, useState } from 'react';
import { CBX003_TREATMENT_KEY, CBX003_GROUP_PARAMETER_OPTIONS, CBX003_GROUP_PARAMETER_KEY, PARAMETERS } from '../constants/experimentKeys'; // CBX-003: Starter suite GWP Positioning: Copy

export const useIsCBX003Variant = () => {
  const [isCbx003Variant, setIsCbx003Variant] = useState();
  useEffect(() => {
    laboratoryClient.resolve(treatments => {
      if (Object.keys(treatments).length) {
        const optionValue = treatments[CBX003_TREATMENT_KEY][PARAMETERS][CBX003_GROUP_PARAMETER_KEY];
        setIsCbx003Variant(optionValue === CBX003_GROUP_PARAMETER_OPTIONS.variant);
      }
    });
  }, [isCbx003Variant]);
  return isCbx003Variant;
};